import { render } from "./Address.vue?vue&type=template&id=03762769&scoped=true"
import script from "./Address.vue?vue&type=script&lang=js"
export * from "./Address.vue?vue&type=script&lang=js"

import "./Address.vue?vue&type=style&index=0&id=03762769&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-03762769"

export default script